/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { Button } from 'reactstrap';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import AuthService from '../../services/AuthService';

// local imports
import ErrorBoundary from '../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';
import TimeoutSound from '../../assets/TimeoutSound.wav';

const StartMeet = props => {

    let audio = new Audio(TimeoutSound);
    let audioCount = 1;
    audio.addEventListener('ended', function () {
        if (audioCount < 1) {
            audioCount += 1;
            this.currentTime = 0;
            this.play();
        }
    }, false)

    // states
    const [time, setTime] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h4>Here you can create your meeting using <b>Zoom</b> and <b>Google Meet</b>!</h4>,
                placement: 'center',
                target: '#startMeetDiv',
            }
        ]
    });
    let helpers = null;

    // contexts
    const { theme } = useContext(ThemeContext);
    const { user, setUser } = useContext(AuthContext);

    // useEffect
    useEffect(() => {
        if (!user.guideTakenFor.includes("StartMeet")) {
            setTutorial({ ...tutorial, status: true });
        }
        if (props.location.state) {
            setTime(props.location.state.duration);
        } else {
            props.history.replace('/counsellor/sessions');
        }
    }, [props.location.state]);


    // handle functions

    //utility functions
    const renderTime = ({ remainingTime }) => {
        let hours = Math.floor(remainingTime / 3600)
        let minutes = Math.floor((remainingTime % 3600) / 60)
        let seconds = remainingTime % 60
        if (hours < 10) { hours = "0" + hours; }
        if (minutes < 10) { minutes = "0" + minutes; }
        if (seconds < 10) { seconds = "0" + seconds; }

        if (remainingTime === 0) {
            return <div style={{ fontSize: '2.5rem' }}>Timeout...</div>;
        }

        return (
            <div className="d-flex h-75 flex-column text-center">
                <div className="time mt-auto" style={{ fontSize: '2.5rem' }}>
                    {hours + ':' + minutes + ':' + seconds}
                </div>
                <div><text style={{ fontSize: '1.2rem' }}>remaining</text></div>
                <div className="mt-auto" style={{ cursor: 'pointer' }} onClick={() => { setIsPlaying(!isPlaying); audio.play(); }}>
                    {
                        isPlaying
                            ? <i className="fas fa-pause-circle" style={{ fontSize: "2.5rem" }}></i>
                            : <i className="fas fa-play-circle" style={{ fontSize: "2.5rem" }}></i>
                    }
                </div>
            </div>
        );
    };

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.guideTakenFor.includes("StartMeet")) {
                AuthService.markVisited("StartMeet");
                setUser({ ...user, guideTakenFor: [...user.guideTakenFor, "StartMeet"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };


    return (
        <div id="startMeetDiv">
            <ErrorBoundary errorAt="At Provider StartMeet ProviderNavbar">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            <ErrorBoundary errorAt="At Provider StartMeet ProviderNavbar">
                <ProviderNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            </ErrorBoundary>
            <div className="p-3">
                {time ?
                    <div className="d-flex justify-content-around">
                        <CountdownCircleTimer isPlaying={isPlaying} size={240} strokeWidth={10} duration={time * 60} colors={[['#004777', 0.33], ['#F7B801', 0.33], ['#A30000', 0.33]]}>
                            {renderTime}
                        </CountdownCircleTimer>
                        {/* <CountdownCircleTimer onComplete={() => [true,1000]} isPlaying={isPlaying} size={240} strokeWidth={10} duration={10} colors={[['#004777', 0.33],['#F7B801', 0.33],['#A30000', 0.33]]}>
                            {renderTime}
                        </CountdownCircleTimer> */}
                    </div> : null
                }
                <div className="d-flex justify-content-around mt-5">
                    <a href="https://meet.google.com/new" target="_blank">
                        <Button style={theme.formSubmit}>Google Meet</Button>
                    </a>
                    <a href="https://zoom.us/start/videomeeting" target="_blank">
                        <Button style={theme.formSubmit}>Zoom</Button>
                    </a>
                </div>
            </div>
        </div>
    )

}

export default StartMeet;